<template>
    <div v-if="state" class="flex items-center justify-center">
        <datepicker
            :value="state.currentRefinements.min"
            format="dd/MM/yy"
            calendar-class="-ml-5"
            @selected="state.refine({ min: $event })"
        >
            <div
                slot="afterDateInput"
                class="flex items-center px-2"
                :class="[fromDateActive ? 'bg-blue-600' : 'bg-blue-500']"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                    <g stroke="#FFF" fill="none" fill-rule="evenodd">
                        <rect width="11" height="9" x=".5" y="2.5" rx="1.5" />
                        <path stroke-linecap="round" d="M3.5.5v1.625M8.5.5v1.625" />
                        <path d="M0 6.5h11" />
                    </g>
                </svg>
            </div>
        </datepicker>

        <span class="mx-4 text-xs">to</span>

        <datepicker
            :value="state.currentRefinements.max"
            format="dd/MM/yy"
            calendar-class="right-0 -mr-5"
            @selected="state.refine({ max: $event })"
        >
            <div
                slot="afterDateInput"
                class="flex items-center px-2 bg-blue-500"
                :class="[toDateActive ? 'bg-blue-600' : 'bg-blue-500']"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                    <g stroke="#FFF" fill="none" fill-rule="evenodd">
                        <rect width="11" height="9" x=".5" y="2.5" rx="1.5" />
                        <path stroke-linecap="round" d="M3.5.5v1.625M8.5.5v1.625" />
                        <path d="M0 6.5h11" />
                    </g>
                </svg>
            </div>
        </datepicker>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { createWidgetMixin } from 'vue-instantsearch';
import connectDateRange from '@/connectors/DateRange';

export default {
    components: {
        Datepicker
    },

    mixins: [createWidgetMixin({ connector: connectDateRange })],

    props: {
        attribute: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            fromDateActive: false,
            toDateActive: false
        };
    },

    computed: {
        widgetParams() {
            return {
                attribute: this.attribute
            };
        }
    }

    // methods: {
    //     toggleActiveClass(attr) {
    //         console.log(attr);
    //         this[attr] = !this[attr];
    //     }
    // }
};
</script>

<style scoped>
::v-deep {
    .vdp-datepicker {
        > div:first-child {
            @apply flex border rounded border-grey-200 text-sm flex-grow overflow-hidden;

            input {
                @apply px-2 py-1 w-20 outline-none text-sm;
            }
        }
    }

    .vdp-datepicker__calendar {
        @apply p-2 text-grey-500;

        header,
        .day-header {
            @apply font-bold !important;
        }

        header {
            @apply flex items-center;
        }

        .next,
        .prev {
            @apply text-grey-300 text-xl font-light;
            text-indent: 0;

            &:after {
                @apply hidden;
            }
        }

        .cell:not(.blank):not(.disabled) {
            @apply text-grey-500 rounded text-sm font-normal;

            &.day {
                @apply rounded-full;
            }

            &:not(.day-header):hover {
                @apply border-transparent bg-grey-200;
            }

            &.selected {
                @apply bg-blue-600 text-white !important;
            }
        }

        .day__month_btn {
            @apply font-medium text-xl font-heading uppercase tracking-widest leading-medium;
        }
    }
}
</style>
